// extracted by mini-css-extract-plugin
export var downArrow = "_8y-0";
export var infoTooltipIcon = "_8y-3";
export var label = "_8y-1";
export var optionCard = "_8y-4";
export var upArrow = "_8y-2";